import _ from 'lodash'

function stripOutDashboardProperty(dashboard, property) {
  dashboard = _.cloneDeep(dashboard)
  dashboard.children = dashboard.children.map(child => {
    if (child.component === 'metric-category') {
      child.children = child.children.map(child2 => {
        return _.omit(child2, property)
      })
    }
    return _.omit(child, property)
  })
  return dashboard
}

function stripOutDashboardNulls(dashboard) {
  dashboard = _.cloneDeep(dashboard)
  dashboard.children = dashboard.children.filter(child => {
    if (child.component === 'metric-category') {
      child.children = child.children.filter(child2 => {
        return child2
      })
    }
    return child
  })
  return dashboard
}

export { stripOutDashboardProperty, stripOutDashboardNulls }
